import { util } from './util'

// Navigation Toggles

class Navigation {
  constructor() {
    this.landingTranslate();
    this.headerDropdown();
    this.headerScroll();
    this.scrollTop();
    this.bannerAnimation();
    
    this.languageToggles = [].slice.call(
      document.querySelectorAll('.footer__toggle')
    );

    this.languageToggles.forEach(toggle => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            var hasCookie = util.getCookie('translated')
            
            if (hasCookie) {
              util.deleteCookie('translated')
            } else {
              util.createCookie('translated', 1)
            }

            this.translateRules()
          }
        });
      });
    });
  }

  landingTranslate() {
    $.get("https://ipinfo.io", function(response) {
      const currentCountry = response.country
      
      // if (currentCountry === 'JP') {
      //   util.createCookie('translated', 1)
      // }

      const hasCookie = util.getCookie('translated')

      this.englishCopy = [].slice.call(
        document.querySelectorAll('.can-translate')
      );
  
      this.translatedCopy = [].slice.call(
        document.querySelectorAll('.translated')
      );

      if (currentCountry === 'JP' || hasCookie) {
        if (this.englishCopy) {
          this.englishCopy.forEach(content => {
            content.classList.add('inactive')
          });
        }
  
        if (this.translatedCopy) {
          this.translatedCopy.forEach(content => {
            content.classList.add('active')
          });
        }
      } else {
        if (this.englishCopy) {
          this.englishCopy.forEach(content => {
            content.classList.remove('inactive')
          });
        }
  
        if (this.translatedCopy) {
          this.translatedCopy.forEach(content => {
            content.classList.remove('active')
          });
        }
      }
    }, "jsonp");
  }

  translateRules() {
    this.englishCopy = [].slice.call(
      document.querySelectorAll('.can-translate')
    );

    this.translatedCopy = [].slice.call(
      document.querySelectorAll('.translated')
    );

    if (this.englishCopy) {
      this.englishCopy.forEach(content => {
        content.classList.toggle('inactive')
      });
    }

    if (this.translatedCopy) {
      this.translatedCopy.forEach(content => {
        content.classList.toggle('active')
      });
    }
  }

  bannerAnimation() {
    this.featuredCollections = [].slice.call(
      document.querySelectorAll('.featured-collection')
    );

    if (this.featuredCollections) {
      this.featuredCollections.forEach(collection => {
        var contentCheck = function() {
          const topDistance = collection.getBoundingClientRect().top;
          
          if (topDistance <= 400) {
            collection.classList.add('isVisible')
          } else if (topDistance > 400) {
            collection.classList.remove('isVisible')
          }
        };
  
        window.addEventListener('scroll', contentCheck);
      });
    }
  }

  scrollTop() {
    this.scrollTriggers = [].slice.call(
      document.querySelectorAll('.footer__back-to-top')
    );

    this.scrollTriggers.forEach(trigger => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        trigger.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            window.scrollTo(0, 0)
          }
        });
      });
    });
  }

  headerDropdown() {
    this.navToggles = [].slice.call(
      document.querySelectorAll('.header__menu__toggle')
    );

    this.navToggles.forEach(toggle => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            let list = toggle.querySelector('.header__dropdown');
            
            toggle.classList.toggle('open');
            list.classList.toggle('active');
            
            if (!toggle.classList.contains('open')) {
              document.querySelector('.header').classList.remove('active');
            } else {
              document.querySelector('.header').classList.add('active');
            }

            if (toggle.classList.contains('header__menu__toggle--collections')) {
              document.querySelector('.header__menu__toggle--shop').classList.remove('open')
              document.querySelector('.header__dropdown--shop').classList.remove('active')
            }

            if (toggle.classList.contains('header__menu__toggle--shop')) {
              document.querySelector('.header__menu__toggle--collections').classList.remove('open')
              document.querySelector('.header__dropdown--collections').classList.remove('active')
            }
          }
        });
      });
    });
  }

  itemHover() {
    const shopList = document.querySelector('.header__dropdown--collections');
    const listImage = shopList.querySelector('.header__dropdown__image img');

    this.listItems = [].slice.call(
      shopList.querySelectorAll('.header__dropdown__list-item')
    );

    this.listItems.forEach(item => {
      item.addEventListener('mouseenter', e => {
        const itemImage = item.dataset.image;

        listImage.src = itemImage;
      })
    });
  }

  headerScroll() {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById('navigation');

    var checkScroll = function() {

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) { 
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }
      
      prevScroll = curScroll;
    };

    var toggleHeader = function(direction, curScroll) {
      if (direction === 2 && curScroll > 120) { 
        
        //replace 52 with the height of your header in px

        header.classList.add('scrolling');
        prevDirection = direction;
      }
      else if (direction === 1 && curScroll <= 0) {
        header.classList.remove('scrolling');
        prevDirection = direction;
      }
    };
    
    window.addEventListener('scroll', checkScroll);
  }
}

const navInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.getElementById('navigation');
    if (wrapperEl !== null) {
      // eslint-disable-next-line no-unused-vars
      const navigationWrap = new Navigation(wrapperEl);
    }
  },
};

export default navInit;
